const contactPage = {
    id: 'kontakt',
    title: 'Kontaktdaten',
    description: 'Damit wir uns bei Ihnen melden können.',
    branches: [],
    fields: [
        { id: 'f_vorname', key: 'vorname', type: 'text', label: 'Vorname', required: true, mapsTo: 'firstName', width: 'half' },
        { id: 'f_nachname', key: 'nachname', type: 'text', label: 'Nachname', required: true, mapsTo: 'lastName', width: 'half' },
        { id: 'f_firma', key: 'firma', type: 'text', label: 'Firma', required: false, mapsTo: 'company', width: 'full' },
        { id: 'f_email', key: 'email', type: 'email', label: 'E-Mail', required: true, mapsTo: 'email', width: 'half' },
        { id: 'f_telefon', key: 'telefon', type: 'phone', label: 'Telefon', required: false, mapsTo: 'phone', width: 'half' },
        { id: 'f_strasse', key: 'strasse', type: 'text', label: 'Straße und Hausnummer', required: false, mapsTo: 'street', width: 'full' },
        { id: 'f_plz', key: 'plz', type: 'text', label: 'PLZ', required: false, mapsTo: 'postalCode', width: 'half' },
        { id: 'f_ort', key: 'ort', type: 'text', label: 'Ort', required: false, mapsTo: 'city', width: 'half' },
    ],
};
export const FORM_TEMPLATES = [
    {
        key: 'service-request',
        name: 'Serviceanfrage (IT-Support oder Hardware-Reparatur)',
        description: 'Mehrseitiges Formular mit Verzweigung: Kontaktdaten, Anliegen, dann passende Fragen zu IT-Problem oder defektem Gerät.',
        kind: 'REQUEST',
        access: 'PUBLIC',
        routing: { fieldKey: 'anliegen', map: { it: 'it', reparatur: 'repair' } },
        defaultAreaKey: 'general',
        definition: {
            submitLabel: 'Anfrage absenden',
            confirmation: { title: 'Vielen Dank für Ihre Anfrage!', message: 'Wir haben Ihre Anfrage erhalten und melden uns schnellstmöglich bei Ihnen.' },
            pages: [
                { ...contactPage, fields: [...contactPage.fields] },
                {
                    id: 'anliegen',
                    title: 'Ihr Anliegen',
                    fields: [
                        {
                            id: 'f_anliegen',
                            key: 'anliegen',
                            type: 'radio',
                            label: 'Worum geht es?',
                            required: true,
                            width: 'full',
                            options: [
                                { value: 'it', label: 'IT-Support' },
                                { value: 'reparatur', label: 'Hardware-Reparatur' },
                            ],
                        },
                    ],
                    branches: [
                        { when: { mode: 'all', conditions: [{ field: 'anliegen', op: 'equals', value: 'it' }] }, goTo: 'it' },
                        { when: { mode: 'all', conditions: [{ field: 'anliegen', op: 'equals', value: 'reparatur' }] }, goTo: 'reparatur' },
                    ],
                },
                {
                    id: 'it',
                    title: 'IT-Support',
                    defaultNext: '__submit__',
                    branches: [],
                    fields: [
                        { id: 'f_system', key: 'system', type: 'text', label: 'Betroffenes System', placeholder: 'z. B. Arbeitsplatz-PC, E-Mail, Server, WLAN', required: true, mapsTo: 'subject', width: 'full' },
                        {
                            id: 'f_problemart',
                            key: 'problemart',
                            type: 'select',
                            label: 'Art des Problems',
                            required: true,
                            width: 'half',
                            options: [
                                { value: 'stoerung', label: 'Störung / Ausfall' },
                                { value: 'fehler', label: 'Fehlermeldung' },
                                { value: 'langsam', label: 'Langsam / instabil' },
                                { value: 'zugang', label: 'Zugang / Passwort' },
                                { value: 'einrichtung', label: 'Einrichtung / Änderung' },
                                { value: 'sonstiges', label: 'Sonstiges' },
                            ],
                        },
                        { id: 'f_seit', key: 'seit', type: 'date', label: 'Seit wann besteht das Problem?', required: false, width: 'half' },
                        { id: 'f_fehlermeldung', key: 'fehlermeldung', type: 'textarea', label: 'Fehlermeldung / Beschreibung', required: true, mapsTo: 'description', width: 'full' },
                        { id: 'f_screens', key: 'screenshots', type: 'file', label: 'Screenshots', required: false, width: 'full', validation: { maxFiles: 5 } },
                    ],
                },
                {
                    id: 'reparatur',
                    title: 'Hardware-Reparatur',
                    defaultNext: '__submit__',
                    branches: [],
                    fields: [
                        { id: 'f_geraetetyp', key: 'geraetetyp', type: 'text', label: 'Gerätetyp', placeholder: 'z. B. Notebook, Fernseher, Verstärker', required: true, mapsTo: 'deviceType', width: 'half' },
                        { id: 'f_hersteller', key: 'hersteller', type: 'text', label: 'Hersteller', required: true, mapsTo: 'manufacturer', width: 'half' },
                        { id: 'f_modell', key: 'modell', type: 'text', label: 'Modell', required: false, mapsTo: 'model', width: 'half' },
                        { id: 'f_seriennummer', key: 'seriennummer', type: 'text', label: 'Seriennummer', required: false, mapsTo: 'serialNumber', width: 'half' },
                        { id: 'f_fehler', key: 'fehlerbeschreibung', type: 'textarea', label: 'Fehlerbeschreibung', required: true, mapsTo: 'description', width: 'full', validation: { minLength: 10 } },
                        { id: 'f_zubehoer', key: 'zubehoer', type: 'text', label: 'Zubehör, das Sie mitbringen', required: false, mapsTo: 'accessories', width: 'full' },
                        { id: 'f_fotos', key: 'fotos', type: 'file', label: 'Fotos', help: 'Fotos vom Defekt helfen uns bei der Einschätzung.', required: false, width: 'full', validation: { maxFiles: 5 } },
                    ],
                },
            ],
        },
    },
    {
        key: 'contact',
        name: 'Kontaktformular',
        description: 'Einseitiges, schlichtes Kontaktformular für die Website.',
        kind: 'REQUEST',
        access: 'PUBLIC',
        defaultAreaKey: 'general',
        definition: {
            submitLabel: 'Senden',
            confirmation: { title: 'Vielen Dank!', message: 'Ihre Nachricht ist bei uns eingegangen.' },
            pages: [
                {
                    id: 'nachricht',
                    title: 'Kontakt',
                    branches: [],
                    fields: [
                        { id: 'c_name', key: 'name', type: 'text', label: 'Name', required: true, mapsTo: 'lastName', width: 'half' },
                        { id: 'c_email', key: 'email', type: 'email', label: 'E-Mail', required: true, mapsTo: 'email', width: 'half' },
                        { id: 'c_betreff', key: 'betreff', type: 'text', label: 'Betreff', required: true, mapsTo: 'subject', width: 'full' },
                        { id: 'c_nachricht', key: 'nachricht', type: 'textarea', label: 'Ihre Nachricht', required: true, mapsTo: 'description', width: 'full' },
                    ],
                },
            ],
        },
    },
    {
        key: 'maintenance-checklist',
        name: 'Wartungscheckliste',
        description: 'Interne Checkliste für Wartungseinsätze; wird an Ticket oder Reparatur gehängt.',
        kind: 'CHECKLIST',
        access: 'INTERNAL',
        definition: {
            submitLabel: 'Checkliste speichern',
            confirmation: { title: 'Gespeichert', message: 'Die Checkliste wurde gespeichert.' },
            pages: [
                {
                    id: 'pruefung',
                    title: 'Prüfpunkte',
                    branches: [],
                    fields: [
                        { id: 'm_sicht', key: 'sichtpruefung', type: 'checkbox', label: 'Sichtprüfung ohne Befund', required: false, width: 'full' },
                        { id: 'm_reinigung', key: 'reinigung', type: 'checkbox', label: 'Gerät gereinigt / Lüfter entstaubt', required: false, width: 'full' },
                        { id: 'm_updates', key: 'updates', type: 'checkbox', label: 'Firmware / Updates aktuell', required: false, width: 'full' },
                        { id: 'm_backup', key: 'backup', type: 'radio', label: 'Datensicherung', required: true, width: 'full', options: [
                                { value: 'ok', label: 'geprüft, in Ordnung' },
                                { value: 'fehler', label: 'fehlerhaft' },
                                { value: 'nv', label: 'nicht vorhanden' },
                            ] },
                        { id: 'm_backup_note', key: 'backup_hinweis', type: 'textarea', label: 'Hinweis zur Datensicherung', required: true, width: 'full', visibleIf: { mode: 'any', conditions: [{ field: 'backup', op: 'equals', value: 'fehler' }, { field: 'backup', op: 'equals', value: 'nv' }] } },
                        { id: 'm_vde', key: 'vde', type: 'checkbox', label: 'Elektrische Sicherheitsprüfung (DGUV V3) bestanden', required: false, width: 'full' },
                        { id: 'm_bemerkung', key: 'bemerkungen', type: 'textarea', label: 'Bemerkungen', required: false, width: 'full' },
                        { id: 'm_fotos', key: 'fotos', type: 'file', label: 'Fotos', required: false, width: 'full' },
                    ],
                },
            ],
        },
    },
];
//# sourceMappingURL=form-templates.js.map